import React from "react";
import AppPreview from "./AppPreview";
import PhotoFilterPreview from "./PhotoFilterPreview";
import DeviceText from "./DeviceText";
import MultiSelect from "./MultiSelect";
import {
  DeviceTextWrapper,
  LogoWrapper,
  UpgradeButtonLinkContainer,
  UpgradeButtonLink,
} from "containers/ChannelsPage/Forms/styledComponents";

import InputField, { Select, File, Date } from "components/InputField";
import { ColorPickerButton } from "components/InputField/File";
import SwitchField from "components/SwitchField";
import ImageSelect from "./ImageSelect";
import {
  FieldHead,
  CenterDiv,
  UpgradeText,
  GroupRadioWrapper,
} from "../styledComponents";
import CheckboxField from "components/CheckboxField";
import { Controller } from "react-hook-form";
import UpgradeCta from "containers/UpgradeCta";

export const ChannelInputField = (props) => {
  return <InputField {...props} />;
};
export const ChannelSelectField = (props) => <Select {...props} />;

export const ChannelAdministratorsSelect = ({ ...props }) => {
  let options = [];
  return <MultiSelect options={options} {...props} />;
};

export const ChannelSwitchField = ({ password, ...props }) => {
  return (
    <SwitchField channelFormPass={true} checked={props.checked} {...props} />
  );
};

export const ChannelGroupRadioInput = ({ value, onChange }) => {
  return (
    <GroupRadioWrapper>
      <input
        type="radio"
        id="own"
        name="useMoveboothTheme"
        value="own_graphics"
        checked={!value}
        onChange={() => onChange(false)}
      ></input>
      <label onClick={() => onChange(false)}>Upload my own graphics</label>
      <br />

      <input
        type="radio"
        id="movebooth"
        name="useMoveboothTheme"
        value="movebooth_theme"
        checked={value}
        onChange={() => onChange(true)}
      ></input>
      <label onClick={() => onChange(true)}>Use a Movebooth theme</label>
      <br />
    </GroupRadioWrapper>
  );
};

export class ChannelDateInputField extends React.Component {
  render() {
    return (
      <Date
        {...this.props}
        date={this.props.value || null}
        disabled={this.props.disabled}
      />
    );
  }
}

export const ChannelFileField = ({
  info,
  instructions,
  labelClassName,
  secondButtonProps,
  ...fieldProps
}) => (
  <File
    accept="image/*"
    secondButtonProps={
      !!secondButtonProps
        ? {
            buttonText: secondButtonProps.buttonText,
            onClick: (siblingRef) =>
              secondButtonProps.onClick({
                siblingRef,
                onChange: fieldProps.onChange,
                hex: secondButtonProps.buttonText,
              }),
          }
        : false
    }
    {...fieldProps}
  >
    <div className="channel-file-field__children">
      <p className="channel-file-field__info">{info}</p>
      <i className="channel-file-field__instructions">{instructions}</i>
    </div>
  </File>
);

// Consider extracting if needed elsewhere
export const ChannelUrlInputField = ({
  channelName,
  channelUrlTimeout,
  setChannelUrlTimeout,
  urlPrefix,
  ...rest
}) => {
  // Use provided urlPrefix or fallback to default
  const displayPrefix = urlPrefix || `${window.location.origin}/ch/`;

  // State for dynamic padding based on prefix width
  const [prefixWidth, setPrefixWidth] = React.useState(100);
  const prefixRef = React.useRef(null);

  // Measure prefix width on mount and when prefix changes
  React.useEffect(() => {
    if (prefixRef.current) {
      // offsetWidth includes padding, so just add a small gap
      const width = prefixRef.current.offsetWidth;
      setPrefixWidth(width);
    }
  }, [displayPrefix]);

  const fix_url = (url) => {
    var urlFixed = url
      .toLowerCase()
      .trimStart()
      .replace(/ /g, "-")
      .replace(/[^a-z\-_0-9]/g, "");

    if (channelUrlTimeout) clearTimeout(channelUrlTimeout);
    setChannelUrlTimeout(
      setTimeout(() => {
        rest.onChange(urlFixed.replace(/[-]+$/, ""));
      }, 600)
    );

    return urlFixed;
  };
  return (
    <div>
      <p ref={prefixRef} className="channel-forms__static-url">{displayPrefix}</p>
      <div>
        <ChannelInputField
          type="text"
          inputClassName="channel-forms__channel-url-input"
          inputStyle={{ paddingLeft: `${prefixWidth}px` }}
          {...rest}
          onFocus={(e) => {
            if (!rest.value) {
              rest.onChange(channelName && fix_url(channelName));
            }

            // return rest.onFocus(e);
          }}
          onChange={(e) => {
            var new_val = fix_url(e.target.value);
            return rest.onChange(new_val);
          }}
        />
      </div>
    </div>
  );
};

export const ChannelHashtagField = ({ channelName, ...rest }) => {
  const fix_hashtag = (hashtag) =>
    hashtag
      .toLowerCase()
      .replace(/ /g, "")
      .replace(/[^#a-z\-_0-9]/g, "");
  return (
    <div>
      <ChannelInputField
        {...rest}
        onChange={(e) => {
          var new_val = e.target.value;
          if (new_val.indexOf("#") !== 0) {
            new_val = "#" + new_val;
          }
          new_val = fix_hashtag(new_val);
          return rest.input.onChange(new_val);
        }}
      />
    </div>
  );
};

export const DeviceTextField = ({ name, ...rest }) => {
  return !!name ? (
    <DeviceText name={name} {...rest} />
  ) : (
    <DeviceText {...rest} />
  );
};

export const Embellishment = ({
  font,
  firstLineSize,
  firstLineFieldName,
  maxFontWidth,
  keydownIsActive,
  firstLine,
  defaultFirstLine,
  secondLineSize,
  secondLineFieldName,
  secondLine,
  defaultSecondLine,
  backgroundUrl,
  isAppLogo,
  withoutFilter,
  lineHeight,
  secondLineFont,
  onShrinkChange,
  secondLineLetterSpacing,
}) => (
  <LogoWrapper
    isAppLogo={isAppLogo}
    style={
      !withoutFilter
        ? {
            backgroundImage: `url(${backgroundUrl})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "contain",
          }
        : {}
    }
  >
    <DeviceTextWrapper>
      <DeviceTextField
        font={font}
        onShrinkChange={onShrinkChange}
        base={firstLineSize}
        name={firstLineFieldName}
        lineHeight={lineHeight}
        maxFontWidth={maxFontWidth}
        keydownIsActive={keydownIsActive}
      >
        {firstLine || defaultFirstLine}
      </DeviceTextField>
      {!!secondLineSize && (
        <DeviceTextField
          font={secondLineFont || font}
          base={secondLineSize}
          onShrinkChange={onShrinkChange}
          name={secondLineFieldName}
          maxFontWidth={maxFontWidth}
          lineHeight={lineHeight}
          letterSpacing={secondLineLetterSpacing}
          keydownIsActive={keydownIsActive}
        >
          {secondLine || defaultSecondLine}
        </DeviceTextField>
      )}
    </DeviceTextWrapper>
  </LogoWrapper>
);

export const BrandFormField = (props) => {
  const {
    header,
    description,
    disable_description,
    type,
    subFields,
    validateFnc,
    validateMsg,
    name,
    brandForm,
    disabled,
    permissionRole,
    value,
    field,
    errMsg,
    validationError,
  } = props;

  const disabledField = disabled && disabled(brandForm);
  var fieldComponent = null;

  const liteUserHasFilter =
    name === "photo_filters" &&
    permissionRole === "lite" &&
    brandForm["photo_filters"] &&
    brandForm["photo_filters"].length
      ? true
      : false;

  switch (type) {
    case "file":
      let fileValue = value;
      if (name === "gallery_banner" && !brandForm["gallery_banner"]) {
        fileValue = brandForm["big_logo_image_url"];
      }
      const inputCustom = { ...field, value: fileValue };

      fieldComponent = (
        <div>
          <ImageSelect {...props} input={inputCustom} />
          <File
            {...props}
            input={inputCustom}
            validateFnc={validateFnc}
            validateMsg={validateMsg}
            accept="image/*"
            label=""
            buttonText="Upload New"
            inputClassName="upload-btn"
            showButton={!liteUserHasFilter}
            errMsg={errMsg}
          ></File>
        </div>
      );
      break;
    case "color":
      const fieldValue = brandForm ? brandForm[field.name] : null;

      fieldComponent = disabledField ? null : (
        <ColorPickerButton
          {...props}
          type="text"
          disabled={disabledField}
          onClick={props.openColorPickerModal}
          buttonText={fieldValue}
          backgroundColor={fieldValue}
          errMsg={errMsg}
        />
      );
      break;
    case "upgrade":
      fieldComponent = (
        <div style={{ marginTop: "10px" }}>
          <CenterDiv>
            <UpgradeButtonLinkContainer>
              <UpgradeCta as={UpgradeButtonLink}>
                {description}
              </UpgradeCta>
            </UpgradeButtonLinkContainer>
          </CenterDiv>
        </div>
      );
      break;
    case "text":
    default:
      // Surface a field-level react-hook-form validation error (e.g. the
      // gallery_cta_link URL guard) through InputField's `errorMsg` so the
      // input shows its error state when the form refuses to submit. Other
      // fields pass `validationError === undefined`, leaving them unchanged.
      fieldComponent = (
        <InputField {...props} errMsg={errMsg} errorMsg={validationError} />
      );
      break;
  }
  return (
    <div>
      {(header || description) && type !== "upgrade" && (
        <FieldHead className="brand">
          <strong>{header}</strong>
          <h3 className={disabledField ? "disabled" : ""}>
            {disabledField && disable_description
              ? disable_description
              : description}
          </h3>
        </FieldHead>
      )}
      {fieldComponent}
      {subFields &&
        subFields
          .filter((x) => x)
          .map((options, idx) =>
            options.name ? (
              <Controller
                control={props.control}
                name={options.name}
                key={idx}
                rules={options.rules}
                render={({ field: { ref, ...fieldRest }, fieldState }) => (
                  <BrandFormField
                    brandForm={brandForm}
                    field={fieldRest}
                    name={options.type}
                    {...fieldRest}
                    {...options}
                    errMsg={errMsg}
                    validationError={fieldState.error?.message}
                  />
                )}
              />
            ) : (
              <BrandFormField
                key={idx}
                brandForm={brandForm}
                field={{}}
                name={options.type}
                {...options}
                errMsg={errMsg}
              />
            )
          )}
    </div>
  );
};

export const SharingFormField = ({
  type,
  formData,
  formDataOnChange,
  ...props
}) => {
  var fieldComponent = null;
  const { field, checked } = props;

  const customOnChange = (value) => {
    var result = [...formData];
    var parts = field.name.split("_");
    var isValueChanged = false;
    const valuePart = parts.pop();
    const newValue = typeof value === "boolean" ? value : value.target.checked;
    result.map((x) => {
      if (
        x.name.replace("_", "").replace(" ", "").toLowerCase() ===
        parts.join(" ").replace("_", "").replace(" ", "").toLowerCase()
      ) {
        if (valuePart === "required" && !x[valuePart] && newValue) {
          x.enabled = true;
        }
        if (valuePart === "enabled" && x[valuePart] && !newValue) {
          x.required = false;
        }
        x[valuePart] = newValue;
        isValueChanged = true;
      }
    });
    if (!isValueChanged) {
      const requiredValue = valuePart === "required" ? newValue : false;
      const enabledValue = valuePart === "enabled" ? newValue : false;
      result.push({
        name: parts.join("_"),
        required:
          valuePart === "enabled" && !enabledValue ? false : requiredValue,
        enabled: requiredValue ? true : enabledValue,
      });
    }

    field.onChange(newValue);
    formDataOnChange(result);
  };

  const fieldProps = {
    ...props,
    checked: props.checked,
    value: props.checked,
    onChange: customOnChange,
  };
  switch (type) {
    case "switch":
      fieldComponent = <SwitchField {...fieldProps} baseSwitch />;
      break;
    case "checkbox":
      fieldComponent = <CheckboxField {...fieldProps} size="14" />;
      break;
  }
  return fieldComponent;
};

export { AppPreview, PhotoFilterPreview, DeviceText };
